const fmtBytes = (b) => (b >= 1024 ** 3 ? `${(b / 1024 ** 3).toFixed(2)} GB` : `${Math.round(b / 1024 ** 2)} MB`);
export const fmtDur = (s) => {
  if (s <= 0) return "0";
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  if (d) return `${d} hari ${h} jam`;
  if (h) return `${h} jam ${m} mnt`;
  return `${m} mnt`;
};

export function SisaVoucher({ s, disabled }) {
  if (disabled) return <span className="text-rose-400">nonaktif</span>;
  if (!s) return <span className="text-muted-foreground">-</span>;
  const rows = [];
  if (s.quota_total) rows.push({ k: "Sisa kuota", v: s.quota_left > 0 ? fmtBytes(s.quota_left) : "habis", pct: s.quota_left / s.quota_total });
  if (s.uptime_total) rows.push({ k: "Sisa", v: s.uptime_left > 0 ? fmtDur(s.uptime_left) : "habis", pct: s.uptime_left / s.uptime_total });
  if (s.expires_at) rows.push({ k: "Berlaku", v: s.expire_left > 0 ? `${fmtDur(s.expire_left)} lagi` : "habis", pct: s.expire_left > 0 ? 1 : 0 });
  else if (s.validity) rows.push({ k: "Berlaku", v: `${s.validity} sejak login pertama`, pct: 1 });
  if (!rows.length) rows.push({ k: "", v: "Unlimited", pct: 1 });
  return (
    <div className="space-y-0.5">
      {rows.map((r) => (
        <div key={r.k} className={r.pct <= 0 ? "text-rose-400" : r.pct < 0.2 ? "text-amber-400" : "text-emerald-500"}>
          {r.k && <span className="text-muted-foreground">{r.k}: </span>}{r.v}
          {r.k && r.k !== "Berlaku" && (
            <div className="h-1 w-24 mt-0.5 rounded-full bg-muted/60 overflow-hidden" data-testid={`sisa-bar-${r.k.toLowerCase().replace(/\s/g, "-")}`}>
              <div className={`h-full rounded-full transition-[width] ${r.pct <= 0 ? "bg-rose-500" : r.pct < 0.2 ? "bg-amber-400" : "bg-emerald-500"}`} style={{ width: `${Math.max(0, Math.min(100, r.pct * 100))}%` }} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
